import _PublicationContentFTR, {
    GetFTRElements,
    GetFTRSelectors,
    GetFTRClassList,
    GetFTRTexts,
} from './publication-content/ts';

import _AxelPublicationContentFTR, {
    AxelGetFTRElements,
    AxelGetFTRSelectors,
    AxelGetFTRClassList,
    AxelGetFTRTexts,
} from './axel-publication-content/ts';

import { enableAxelArticleWidget } from './variables/js';

export {
    _PublicationContentFTR as PublicationContentFTR,
    _AxelPublicationContentFTR as AxelPublicationContentFTR,
    GetFTRElements,
    GetFTRSelectors,
    GetFTRClassList,
    GetFTRTexts,
    AxelGetFTRElements,
    AxelGetFTRSelectors,
    AxelGetFTRClassList,
    AxelGetFTRTexts,
};

export default enableAxelArticleWidget ? _PublicationContentFTR : _AxelPublicationContentFTR;
